import axios from "axios";

// The stable codes contractsapi refuses a Generate with. Only the ones the
// editor words for itself are listed; every other code keeps the fallback.
export enum ProposalGenerateErrorCode {
  DEAL_CLOSED = "DEAL_CLOSED",
  SNAPSHOT_CONTRACT = "SNAPSHOT_CONTRACT",
  DUPLICATE_CONTRACT = "DUPLICATE_CONTRACT",
  NO_LIVE_CONTRACT = "NO_LIVE_CONTRACT",
  NO_ACTIVE_TEMPLATE = "NO_ACTIVE_TEMPLATE"
}

const KEY_PREFIX = "contracts.proposals.generateRefused";

const MESSAGE_KEY_BY_CODE: Record<ProposalGenerateErrorCode, string> = {
  [ProposalGenerateErrorCode.DEAL_CLOSED]: `${KEY_PREFIX}.dealClosed`,
  [ProposalGenerateErrorCode.SNAPSHOT_CONTRACT]: `${KEY_PREFIX}.contractCopy`,
  [ProposalGenerateErrorCode.DUPLICATE_CONTRACT]: `${KEY_PREFIX}.contractCopy`,
  [ProposalGenerateErrorCode.NO_LIVE_CONTRACT]: `${KEY_PREFIX}.noContract`,
  [ProposalGenerateErrorCode.NO_ACTIVE_TEMPLATE]: `${KEY_PREFIX}.noTemplate`
};

// Own-property only: `in` would accept inherited names like "toString".
const isKnownCode = (code: unknown): code is ProposalGenerateErrorCode =>
  typeof code === "string" &&
  Object.prototype.hasOwnProperty.call(MESSAGE_KEY_BY_CODE, code);

// The i18n key for a failed Generate or Regenerate, read from the refusal's
// `code`. The server's own `message` is written for a log and is not shown.
export const generateErrorMessageKey = (
  error: unknown,
  fallbackKey: string
): string => {
  const code = axios.isAxiosError(error)
    ? (error.response?.data as { code?: unknown } | undefined)?.code
    : undefined;
  return isKnownCode(code) ? MESSAGE_KEY_BY_CODE[code] : fallbackKey;
};
